/* eslint-disable indent */
import angular from 'angular';
import uiRouter from 'angular-ui-router';

import MobilePayWithAlipayDetailsComponent from './mobilePayWithAlipay.component';

const MobilePayWithAlipayModule = angular.module('tinaba.components.services.mobilePayWithAlipay', [
    uiRouter
])
.config(($stateProvider) => {
    'ngInject';
    $stateProvider.state('services.mobilePayWithAlipay', {
        url: '/mobilePayWithAlipay',
        template: '<mobile-pay-with-alipay-details></mobile-pay-with-alipay-details>'
    });
})
.component('mobilePayWithAlipayDetails', MobilePayWithAlipayDetailsComponent);

export default MobilePayWithAlipayModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/mobilePayWithAlipay/mobilePayWithAlipay.js
 **/